import { Box, InputBase, IconButton } from "@mui/material";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import Shbutton from "../../../../theme/buttons/Shbutton";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import Text from "../../../../theme/text/Text";
import Dropdown from "../../../../theme/dropout/DropOut";
import { useEffect, useState } from "react";
import ButtonGroup from "../../../../theme/buttons/ButtonGroup";
import { useDeleteWebshopCredentialsMutation, useEditWebshopCredentialsMutation, useSyncWebshopProductsMutation } from "../../../../../newapi/webshop/webshopSlice";

import { useTranslation } from "react-i18next";
import { showToastMessageDeleteRequest, showToastMessageUpdateRequest, showToastMessageSyncProductsRequestError} from "../../../../../utils/toasts";
import MConfirmDelete from "../../../Modals/MConfirmDelete";
import MConfirmation from "../../../Modals/MConfirmation";
import MDynamicValues from "../../../Modals/MDynamicValues";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import cx from "classnames"
import { useGetRelationsQuery } from "../../../../../newapi/global/relation/relationSlice";
import NumberInput from "../../../../theme/inputs/NumberInput";
import EMGeneralExplainerBox from "../../../ModalsPopover/explainers/EMGeneralExplainerBox";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../utils/permissions";
import { useSelector } from "react-redux";
import { ENV_TYPES } from "../../../Sidebar";
import SpDesktopFooter from "../../../../theme/sidepanel2/SidepanelFooter";
import { useGetSettingsQuery } from "../../../../../newapi/global/generalApiSlice";
import { countriesFromLocale } from '../../../../../utils/countries';
import { InputDropdown } from "../../../../theme/dropdowns/InputDropdown";
import ShValidatedInput from "../../../../theme/inputs/ShValidatedInput";

// Returns a copy of value that only updates after it has stopped changing for `delay` ms.
// Used to keep search inputs responsive while deferring the expensive list filtering.
const useDebounce = (value, delay = 250) => {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const handle = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(handle);
    }, [value, delay]);
    return debounced;
};

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return props.hasModifyPermission ?
        <ButtonGroup version={2}>
            <Shbutton
                    isLoading={props.isLoading}
                    className={"group-btn"}
                    onClick={props.deleteAction}
                    color="red"
                    variant="contained"
                endIcon={<DeleteIcon />}
            >
                {t('delete')}
            </Shbutton>
            <Shbutton
                sx={{
                    marginLeft: 1
                }}
                isLoading={props.isLoading}
                className={"group-btn"}
                onClick={props.action}
                color={theme.palette.mode === "dark" ? "blue" : "primary"}
                variant="contained"
                endIcon={<SaveIcon />}
            >
                {t('save')}
            </Shbutton>
        </ButtonGroup> : <></>;
};

const Sync = (props) => {
    const  { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [open, setOpen] = useState(false);

    // Confirmation for toggling shipment processing: users must acknowledge that
    // disabling means orders are no longer auto-marked as processed in the webshop.
    const [shipmentConfirm, setShipmentConfirm] = useState({ open: false, value: false });

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];
    
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    const [showCreateproducts, setShowCreateProducts] = useState(false);
    const [showUpdateproducts, setShowUpdateProducts] = useState(false);
    const { data: settings} = useGetSettingsQuery("webshop_sync_");
    const { data: trackAndTraceSettings } = useGetSettingsQuery("allow_track_and_trace_mails");
    const showTrackAndTraceMails = trackAndTraceSettings?.find(s => s.key === "allow_track_and_trace_mails")?.value === "true";
    const language = useSelector((state) => state.settings.language);
    const countries = countriesFromLocale(language);

    useEffect(() => {
        if(settings){
            for(let i = 0; i < settings.length; i++){
                const setting = settings[i];
                if(setting.key === "webshop_sync_create_products"){
                    if(setting.value === 'true'){
                        setShowCreateProducts(true);
                    } else {
                        handleChange("syncCreateProducts","false")
                    }
                } else if(setting.key === "webshop_sync_update_products"){
                    if(setting.value === 'true'){
                        setShowUpdateProducts(true);
                    } else {
                        handleChange("syncUpdateProducts","false")
                    }
                }
            }
        }
    }, [settings])

    const hasModifyPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.WEBSHOPCREDENTIALS_MANAGE, UserPrivileges.SETTINGS_ALL])
    );

    const shopsWithPrefixOptions = ["magento", "shopify"];

    const [credentialsInfo, setCredentialsInfo] = useState({
      id: 0,
      dimensions: null,
      webshopcredentials: null,
      webshop_type: "",
      description: "",
      token: "",
      syncProducts: false,
      syncStock: false,
      syncOrders: false,
      syncCreateProducts: false,
      snooze: false,
      virtualSyncAmount: 0,
      dropshipOrders: false,
      validationSettings: {},
      productFields: {}
    });

    const [credentialsArray, setCredentialsArray] = useState([{key: "", credentials: {}}]);

   // const { data: shippers } = useGetShippersSelectQuery();

    useEffect(() => {
        setCredentialsInfo(props.data);

        if (props.data?.credentials) {
            setCredentialsArray([{key: props.data.webshop_type, credentials: props.data.credentials}]);
        }
    },[props.data]);

    const handleChange = (key, value) => {
        // Handle nested keys with dot notation (e.g., "validationSettings.ignoreAddressCountries")
        if (key.includes('.')) {
            const [parentKey, childKey] = key.split('.');
            setCredentialsInfo({
                ...credentialsInfo,
                [parentKey]: {
                    ...(credentialsInfo[parentKey] || {}),
                    [childKey]: value
                }
            });
        } else {
            setCredentialsInfo({...credentialsInfo, [key]: value});
        }
    };

    // Auto cancel confirms bol cancellation requests, ignoring them cannot be combined with that
    const handleAutoCancelOrdersChange = (value) => {
        if (value && credentialsInfo?.webshop_type === "bol") {
            setCredentialsInfo({
                ...credentialsInfo,
                autoCancelOrders: true,
                credentials: {
                    ...(credentialsInfo.credentials || {}),
                    ignoreCancellationRequests: false
                }
            });
        } else {
            handleChange("autoCancelOrders", value);
        }
    };

    const handleIgnoreCancellationRequestsChange = (value) => {
        setCredentialsInfo({
            ...credentialsInfo,
            autoCancelOrders: value ? false : credentialsInfo.autoCancelOrders,
            credentials: {
                ...(credentialsInfo.credentials || {}),
                ignoreCancellationRequests: value
            }
        });
    };
    
    const confirmShipmentChange = () => {
        handleChange("syncShipments", shipmentConfirm.value);
    };

    const [EditWebshopCredentials,{isLoading}] = useEditWebshopCredentialsMutation();
    const handleSaveClick = async () => {
        try {
            if (isLoading) return;

            const { state, ...credentialsWithoutState } = credentialsInfo;

            // Filter null and empty strings
            if (credentialsWithoutState.ignoreBarcodes && credentialsWithoutState.ignoreBarcodes.length > 0) {
                credentialsWithoutState.ignoreBarcodes = credentialsWithoutState.ignoreBarcodes.filter(x => x && x.length > 0);
            }

            // Filter null and empty strings
            if (credentialsWithoutState.ignoreStockBarcodes && credentialsWithoutState.ignoreStockBarcodes.length > 0) {
                credentialsWithoutState.ignoreStockBarcodes = credentialsWithoutState.ignoreStockBarcodes.filter(x => x && x.length > 0);
            }

            // Filter null and empty strings
            if (credentialsWithoutState.importBarcodeWhitelist && credentialsWithoutState.importBarcodeWhitelist.length > 0) {
                credentialsWithoutState.importBarcodeWhitelist = credentialsWithoutState.importBarcodeWhitelist.filter(x => x && x.length > 0);
            }

            const response = await EditWebshopCredentials(credentialsWithoutState).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (err) {
            showToastMessageUpdateRequest(t, {success: false, error: err.error});
        }
    };

    const [SyncWebshopProducts,{syncIsLoading}] = useSyncWebshopProductsMutation();
    const handleSyncClick = async () => {
        try {
            const response = await SyncWebshopProducts({id: credentialsInfo?.id}).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (err) {
            showToastMessageSyncProductsRequestError(t, err);
        }
    };
    const [DeleteWebshopCredentialsMutation] = useDeleteWebshopCredentialsMutation();
    const handleDeleteClick = async () => {
      setOpen(true);
    };
    const confirmDelete = async () => {
        try {
            const response = await DeleteWebshopCredentialsMutation(props.data.id).unwrap();
            showToastMessageDeleteRequest(t, response);
            props.setIsExtended(false);
        } catch (err) {
            showToastMessageDeleteRequest(t, {success: false, error: err.error});
        }
    };

    const confirmDeleteModal = {
        data: credentialsInfo?.description,
        open: open,
        setOpen: setOpen,
        confirm: confirmDelete
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            mobileActions:<GridActions 
                hasModifyPermission={hasModifyPermission}
                isLoading={isLoading}
                id={credentialsInfo?.id}
                action={handleSaveClick}
                syncAction={handleSyncClick}></GridActions>,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[credentialsInfo,handleSaveClick,handleSyncClick]);

    // Fetch relations using the useGetRelationsQuery hook
    const { data: relationsData, isLoading: relationsLoading } = useGetRelationsQuery({
        args: { page: 1, size: 100, body: {} }, // Adjust the args as needed
    });

    const handleBarcodeChange = (index, value) => {
        const barcodeCopy = credentialsInfo.ignoreBarcodes;
        barcodeCopy[index] = value;

        setCredentialsInfo({...credentialsInfo, ignoreBarcodes: barcodeCopy});
    }

    const handleDeleteBarcode = (index) => {
        setCredentialsInfo(prevInfo => ({
            ...prevInfo,
            ignoreBarcodes: prevInfo.ignoreBarcodes.filter((_, i) => i !== index)
        }));
    }

    const handleNewBarcodeRow = () => {
        setCredentialsInfo(prevInfo => ({
            ...prevInfo,
            ignoreBarcodes: prevInfo.ignoreBarcodes ? [...prevInfo.ignoreBarcodes, ""] : [""]
        }));
    }

    const handleStockBarcodeChange = (index, value) => {
        const barcodeCopy = credentialsInfo.ignoreStockBarcodes;
        barcodeCopy[index] = value;

        setCredentialsInfo({...credentialsInfo, ignoreStockBarcodes: barcodeCopy});
    }

    const handleDeleteStockBarcode = (index) => {
        setCredentialsInfo(prevInfo => ({
            ...prevInfo,
            ignoreStockBarcodes: prevInfo.ignoreStockBarcodes.filter((_, i) => i !== index)
        }));
    }

    const handleNewStockBarcodeRow = () => {
        setCredentialsInfo(prevInfo => ({
            ...prevInfo,
            ignoreStockBarcodes: prevInfo.ignoreStockBarcodes ? [...prevInfo.ignoreStockBarcodes, ""] : [""]
        }));
    }

    const handleWhitelistBarcodeChange = (index, value) => {
        const barcodeCopy = credentialsInfo.importBarcodeWhitelist;
        barcodeCopy[index] = value;

        setCredentialsInfo({...credentialsInfo, importBarcodeWhitelist: barcodeCopy});
    }

    const handleDeleteWhitelistBarcode = (index) => {
        setCredentialsInfo(prevInfo => ({
            ...prevInfo,
            importBarcodeWhitelist: prevInfo.importBarcodeWhitelist.filter((_, i) => i !== index)
        }));
    }

    const handleNewWhitelistBarcodeRow = () => {
        setCredentialsInfo(prevInfo => ({
            ...prevInfo,
            importBarcodeWhitelist: prevInfo.importBarcodeWhitelist ? [...prevInfo.importBarcodeWhitelist, ""] : [""]
        }));
    }

    // Search filters for the barcode lists and open state for the bulk-add modals
    const [ignoreBarcodeSearch, setIgnoreBarcodeSearch] = useState("");
    const [whitelistBarcodeSearch, setWhitelistBarcodeSearch] = useState("");
    // Debounced copies drive the actual filtering so the list isn't re-rendered on every keystroke
    const debouncedIgnoreBarcodeSearch = useDebounce(ignoreBarcodeSearch);
    const debouncedWhitelistBarcodeSearch = useDebounce(whitelistBarcodeSearch);
    const [showBulkIgnoreModal, setShowBulkIgnoreModal] = useState(false);
    const [showBulkWhitelistModal, setShowBulkWhitelistModal] = useState(false);

    // Splits a comma/newline separated string into a cleaned list of barcodes
    const parseBulkBarcodes = (formValues) => {
        return (formValues?.barcodes ?? "")
            .split(/[,\r\n]+/)
            .map(barcode => barcode.trim())
            .filter(barcode => barcode.length > 0);
    }

    const handleBulkAddIgnoreBarcodes = (formValues) => {
        const parsed = parseBulkBarcodes(formValues);
        if (parsed.length === 0) return;

        setCredentialsInfo(prevInfo => ({
            ...prevInfo,
            ignoreBarcodes: [...(prevInfo.ignoreBarcodes ?? []), ...parsed]
        }));
    }

    const handleBulkAddWhitelistBarcodes = (formValues) => {
        const parsed = parseBulkBarcodes(formValues);
        if (parsed.length === 0) return;

        setCredentialsInfo(prevInfo => ({
            ...prevInfo,
            importBarcodeWhitelist: [...(prevInfo.importBarcodeWhitelist ?? []), ...parsed]
        }));
    }

    // Fields config for the bulk-add modal — a single large textarea that accepts
    // hundreds of comma separated barcodes (well beyond the 2000 character requirement).
    const bulkBarcodeFields = [
        {
            name: "barcodes",
            label: "",
            type: "custom",
            width: 1,
            render: ({ value, onChange }) => (
                <Box
                    sx={{
                        flex: 1,
                        width: 1,
                        backgroundColor: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],
                        borderRadius: 2,
                        display: "flex",
                        py: 1,
                    }}
                >
                    <InputBase
                        multiline
                        minRows={5}
                        maxRows={14}
                        placeholder={t("bulk_barcodes_placeholder")}
                        sx={{
                            px: 2,
                            flex: 1,
                            color: colors.txt["primary"],
                        }}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </Box>
            ),
        },
    ];

    const bulkBarcodeMessage = (
        <Box
            sx={{
                background: colors.orange[100],
                py: 1,
                px: 2,
                borderRadius: 2,
                maxWidth: "400px",
                border: `1px solid ${colors.orange[400]}`,
                mx: 3,
            }}
        >
            <Text>{t("bulk_barcodes_message")}</Text>
        </Box>
    );

    const allWebshopTypes = ["woocommerce", "shopify", "magento", "lightspeed", "lightspeed_ecom", "prestashop", "ccvshop", "plugandpay", "shopware6"];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"} paddingX={3}
            sx={{
                "@media screen and (min-width: 48.1em)"  :{
                    marginBottom:11
                }
            }}
        >
            <Dropdown title={t("synchronisations")} open>
                <Text bold>{t("orders")}</Text>
                <Box
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Text noBreak>{t("sync_orders")}</Text>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.syncOrders === true ? "green" : "red"}
                            value={credentialsInfo?.syncOrders === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("syncOrders", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.syncOrders}`, {
                                'active': credentialsInfo?.syncOrders === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        
                    </Box>
                </Box>
                {typeof credentialsInfo?.dropshipOrders !== "undefined" &&
                    <Box 
                        sx={{
                            mt:1.5,
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        
                        <Text noBreak>{t("dropshipping")}</Text>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32
                            }}
                        >
                            <ToggleButtonGroup
                                color={credentialsInfo?.dropshipOrders === true ? "green" : "red"}
                                value={credentialsInfo?.dropshipOrders === true ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("dropshipOrders", value === "true")}
                                aria-label="Active"
                                className={cx(`${credentialsInfo?.dropshipOrders}`, {
                                    'active': credentialsInfo?.dropshipOrders === true
                                })}
                                sx={{
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                            
                        </Box>
                    </Box>
                }
                
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                        mt:1.5,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("all_orders_b2b")}</Text>
                        <EMGeneralExplainerBox title={t('all_orders_b2b')} text={t('em_all_orders_b2b_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.onlyB2BOrders === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.onlyB2BOrders === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.onlyB2BOrders", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.onlyB2BOrders}`, {
                                'active': credentialsInfo?.credentials?.onlyB2BOrders === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        
                    </Box>
                </Box>
                {credentialsInfo?.webshop_type === "woocommerce" && (
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                        mt:1.5,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("set_customer_note_in_remark")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.setCustomerNoteInRemark === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.setCustomerNoteInRemark === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.setCustomerNoteInRemark", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.setCustomerNoteInRemark}`, {
                                'active': credentialsInfo?.credentials?.setCustomerNoteInRemark === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        
                    </Box>
                </Box>
                )}
                {["bol", "shopify", "woocommerce"].includes(credentialsInfo?.webshop_type) && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("auto_cancel_orders")}</Text>
                        {["shopify", "woocommerce"].includes(credentialsInfo?.webshop_type) && (
                            <EMGeneralExplainerBox title={t('auto_cancel_orders')} text={t('em_auto_cancel_orders_webshop_text')}/>
                        )}
                        {credentialsInfo?.webshop_type === "bol" && (
                            <EMGeneralExplainerBox title={t('em_auto_cancel_orders_title')} text={t('em_auto_cancel_orders_text')}/>
                        )}
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.autoCancelOrders === true ? "green" : "red"}
                            value={credentialsInfo?.autoCancelOrders === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleAutoCancelOrdersChange(value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.autoCancelOrders}`, {
                                'active': credentialsInfo?.autoCancelOrders === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                )}
                {credentialsInfo?.webshop_type === "bol" && (
                <Box
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >

                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("ignore_cancellation_requests")}</Text>
                        <EMGeneralExplainerBox title={t('ignore_cancellation_requests')} text={t('em_ignore_cancellation_requests_text')}/>
                    </Box>

                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.ignoreCancellationRequests === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.ignoreCancellationRequests === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleIgnoreCancellationRequestsChange(value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.ignoreCancellationRequests}`, {
                                'active': credentialsInfo?.credentials?.ignoreCancellationRequests === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                )}
                {!isRelation &&
                    <Box
                        sx={{
                            mt:1.5,
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        
                        <Text noBreak>{t("snooze_all_incoming_orders")}</Text>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32
                            }}
                        >
                            <ToggleButtonGroup
                                color={credentialsInfo?.snooze === true ? "green" : "red"}
                                value={credentialsInfo?.snooze === true ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("snooze", value === "true")}
                                aria-label="Active"
                                className={cx(`${credentialsInfo?.snooze}`, {
                                    'active': credentialsInfo?.snooze === true
                                })}
                                sx={{
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                            
                        </Box>
                    </Box>
                }
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("auto_split_orders")}</Text>
                        <EMGeneralExplainerBox title={t('auto_split_orders')} text={t('em_auto_split_orders_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.autoSplitOrders === true ? "green" : "red"}
                            value={credentialsInfo?.autoSplitOrders === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("autoSplitOrders", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.autoSplitOrders}`, {
                                'active': credentialsInfo?.autoSplitOrders === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                {credentialsInfo?.webshop_type === "mirakl" && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("auto_accept_orders")}</Text>
                        <EMGeneralExplainerBox title={t('auto_accept_orders')} text={t('em_mirakl_auto_accept_orders_text')}></EMGeneralExplainerBox>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.autoAcceptLines === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.autoAcceptLines === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.autoAcceptLines", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.autoAcceptLines}`, {
                                'active': credentialsInfo?.credentials?.autoAcceptLines === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                )}
                {credentialsInfo?.webshop_type === "woocommerce" && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("cash_register_orders")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.hasRegisterOrders === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.hasRegisterOrders === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.hasRegisterOrders", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.hasRegisterOrders}`, {
                                'active': credentialsInfo?.credentials?.hasRegisterOrders === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                )}
                {credentialsInfo?.credentials?.hasRegisterOrders && (
                    <Box
                        sx={{
                        mt:1.5,
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("meta_field_cash_register")}</Text>
                            <EMGeneralExplainerBox title={t('meta_field_cash_register')} text={t('em_meta_field_cash_register_text')}></EMGeneralExplainerBox>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.registerOrderMetaKey"
                                value={credentialsInfo?.credentials?.registerOrderMetaKey ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                )}
                {credentialsInfo?.webshop_type === "woocommerce" && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("import_on_hold_b2b_orders")}</Text>
                        <EMGeneralExplainerBox title={t('import_on_hold_b2b_orders')} text={t('em_import_on_hold_b2b_orders_text')}></EMGeneralExplainerBox>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.importOnHoldB2BOrders === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.importOnHoldB2BOrders === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.importOnHoldB2BOrders", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.importOnHoldB2BOrders}`, {
                                'active': credentialsInfo?.credentials?.importOnHoldB2BOrders === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                )}

                {credentialsInfo?.webshop_type === "shopify" && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("import_order_delay")}</Text>
                        <EMGeneralExplainerBox title={t('import_order_delay')} text={t('em_import_order_delay_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <NumberInput btnSize={"24"}
                            maxWidth={160}
                            value={credentialsInfo?.credentials?.importOrderDelay}
                            change={(e) => handleChange("credentials.importOrderDelay", e)}
                        />
                    </Box>
                </Box>
                )}
                {credentialsInfo?.webshop_type === "magento" && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("date_planned_attribute")}</Text>
                        <EMGeneralExplainerBox title={t('date_planned_attribute')} text={t('em_magento_date_planned_attribute_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.hasDatePlannedAttribute === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.hasDatePlannedAttribute === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.hasDatePlannedAttribute", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.hasDatePlannedAttribute}`, {
                                'active': credentialsInfo?.credentials?.hasDatePlannedAttribute === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                )}
                <Text bold sx={{mt: 2}}>{t("order_lines")}</Text>
                {allWebshopTypes.includes(credentialsInfo?.webshop_type) && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("ignore_rows_wo_sku")}</Text>
                        <EMGeneralExplainerBox title={t('ignore_rows_wo_sku')} text={t('em_ignore_rows_wo_sku_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.ignoreEmptyOrderRows === true ? "green" : "red"}
                            value={credentialsInfo?.ignoreEmptyOrderRows === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("ignoreEmptyOrderRows", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.ignoreEmptyOrderRows}`, {
                                'active': credentialsInfo?.ignoreEmptyOrderRows === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        
                    </Box>
                </Box>
                )}
                {["shopify", "woocommerce"].includes(credentialsInfo?.webshop_type) && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("skip_order_on_skipped_row")}</Text>
                        <EMGeneralExplainerBox title={t('skip_order_on_skipped_row')} text={t('em_skip_order_on_skipped_row_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.skipOrderOnSkippedRow === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.skipOrderOnSkippedRow === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.skipOrderOnSkippedRow", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.skipOrderOnSkippedRow}`, {
                                'active': credentialsInfo?.credentials?.skipOrderOnSkippedRow === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        
                    </Box>
                </Box>
                )}
                {credentialsInfo?.webshop_type === "shopify" && (
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                        mt:1.5,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("import_lines_from_location")}</Text>
                        <EMGeneralExplainerBox title={t('import_lines_from_location')} text={t('em_import_lines_from_location_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.import_lines_from_location === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.import_lines_from_location === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.import_lines_from_location", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.import_lines_from_location}`, {
                                'active': credentialsInfo?.credentials?.import_lines_from_location === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        
                    </Box>
                </Box>
                )}
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("orderrows_use_stockhub_sale_price")}</Text>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.rowsUseStockhubSalePrice === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.rowsUseStockhubSalePrice === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.rowsUseStockhubSalePrice", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.rowsUseStockhubSalePrice}`, {
                                'active': credentialsInfo?.credentials?.rowsUseStockhubSalePrice === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>

                <Text bold sx={{mt: 2}}>{t("products")}</Text>
                {(showUpdateproducts) &&
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        
                        <Text noBreak>{t("sync_products")}</Text>
                        
                        <Box
                            sx={{

                                borderRadius:4,
                                display:"flex",
                                height:32
                            }}
                        >
                            <ToggleButtonGroup
                                        color={credentialsInfo?.syncProducts === true ? "green" : "red"}
                                        value={credentialsInfo?.syncProducts === true ? "true" : "false"}
                                        exclusive
                                        onChange={(e,value) => handleChange("syncProducts", value === "true")}
                                        aria-label="Active"
                                        className={cx(`${credentialsInfo?.syncProducts}`, {
                                            'active': credentialsInfo?.syncProducts === true
                                        })}
                                        sx={{
                                            background: colors.red[100],
                                            padding:0.5,
                                            borderRadius:5,
                                            transition:"250ms",
                                            "&.active" : {
                                                background:colors.green[100],
                                                transition:"250ms",
                                            },
                                        }}
                                    >
                                        <ToggleButton 
                                            sx={{
                                                padding:0,
                                                paddingX:2,
                                                border:0,
                                                lineHeight:"32px",
                                                textTransform:"unset",
                                                borderRadius:"32px !important",
                                                color:colors.green[400],
                                                transition:"250ms",
                                                "&.Mui-selected,&.Mui-selected:hover" : {
                                                    background:colors.red[400],
                                                    color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                                }
                                            }}
                                            value="false">
                                            {t('inactive')}
                                        </ToggleButton>
                                        <ToggleButton 
                                            sx={{
                                                padding:0,
                                                paddingX:2,
                                                border:0,
                                                lineHeight:"32px",
                                                textTransform:"unset",
                                                borderRadius:"32px !important",
                                                color:colors.red[400],
                                                transition:"250ms",
                                                "&.Mui-selected,&.Mui-selected:hover" : {
                                                    background:colors.green[400],
                                                    color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                                }
                                            }}
                                            value="true"
                                        >
                                            {t('active')}
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                            
                        </Box>
                    </Box>
                }
                {(showCreateproducts || !isRelation) &&
                    <Box 
                        sx={{
                            mt:1.5,
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        
                        <Text noBreak>{t("sync_create_products")}</Text>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32
                            }}
                        >
                            <ToggleButtonGroup
                                color={credentialsInfo?.syncCreateProducts === true ? "green" : "red"}
                                value={credentialsInfo?.syncCreateProducts === true ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("syncCreateProducts", value === "true")}
                                aria-label="Active"
                                className={cx(`${credentialsInfo?.syncCreateProducts}`, {
                                    'active': credentialsInfo?.syncCreateProducts === true
                                })}
                                sx={{
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                            
                        </Box>
                    </Box>
                }
                {!isRelation && typeof credentialsInfo?.dropshipOrders !== "undefined" && allWebshopTypes.includes(credentialsInfo?.webshop_type) && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("create_stock_amount_for_new_product")}</Text>
                        <EMGeneralExplainerBox title={t('create_stock_amount_for_new_product')} text={t('em_create_stock_amount_for_new_product_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <NumberInput btnSize={"24"}
                            maxWidth={160}
                            value={credentialsInfo?.credentials?.createStockAmountkNewProduct}
                            change={(e) => handleChange("credentials.createStockAmountkNewProduct", e)}
                        />
                    </Box>
                </Box>
                )}
                {!isRelation && (typeof credentialsInfo?.dropshipOrders !== "undefined" || !isFulfilment) && credentialsInfo?.webshop_type === "shopify" && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("use_sku_for_sync")}</Text>
                        <EMGeneralExplainerBox title={t('use_sku_for_sync')} text={t('em_use_sku_for_sync_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                            <ToggleButtonGroup
                                color={credentialsInfo?.credentials?.useSKUForSync === true ? "green" : "red"}
                                value={credentialsInfo?.credentials?.useSKUForSync === true ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("credentials.useSKUForSync", value === "true")}
                                aria-label="Active"
                                className={cx(`${credentialsInfo?.credentials?.useSKUForSync}`, {
                                    'active': credentialsInfo?.credentials?.useSKUForSync === true
                                })}
                                sx={{
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                    </Box>
                </Box>
                )}
                {!isRelation && typeof credentialsInfo?.dropshipOrders !== "undefined" && credentialsInfo?.webshop_type === "shopify" && (
                    <Box 
                        sx={{
                            mt:1.5,
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        
                        <Text noBreak>{t("wc_sync_update_sku")}</Text>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32
                            }}
                        >
                            <ToggleButtonGroup
                                color={credentialsInfo?.credentials?.updateProductSKU === true ? "green" : "red"}
                                value={credentialsInfo?.credentials?.updateProductSKU === true ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("credentials.updateProductSKU", value === "true")}
                                aria-label="Active"
                                className={cx(`${credentialsInfo?.credentials?.updateProductSKU}`, {
                                    'active': credentialsInfo?.credentials?.updateProductSKU === true
                                })}
                                sx={{
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                            
                        </Box>
                    </Box>
                )}
                {!isRelation && credentialsInfo?.webshop_type === "woocommerce" && (
                    <Box 
                        sx={{
                            mt:1.5,
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        
                        <Text noBreak>{t("wc_sync_update_description")}</Text>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32
                            }}
                        >
                            <ToggleButtonGroup
                                color={credentialsInfo?.credentials?.updateProductDescription === true ? "green" : "red"}
                                value={credentialsInfo?.credentials?.updateProductDescription === true ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("credentials.updateProductDescription", value === "true")}
                                aria-label="Active"
                                className={cx(`${credentialsInfo?.credentials?.updateProductDescription}`, {
                                    'active': credentialsInfo?.credentials?.updateProductDescription === true
                                })}
                                sx={{
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                            
                        </Box>
                    </Box>
                )}
                <Text bold sx={{mt: 2}}>{t("stock")}</Text>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Text noBreak>{t("sync_stock")}</Text>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.syncStock === true ? "green" : "red"}
                            value={credentialsInfo?.syncStock === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("syncStock", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.syncStock}`, {
                                'active': credentialsInfo?.syncStock === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                
                    </Box>
                </Box>
                {credentialsInfo?.webshop_type === "magento" && (
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("sync_stock_in_bulk")}</Text>
                        <EMGeneralExplainerBox title={t('sync_stock_in_bulk')} text={t('em_magento_sync_stock_in_bulk_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.bulkStockSyncEnabled === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.bulkStockSyncEnabled === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.bulkStockSyncEnabled", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.bulkStockSyncEnabled}`, {
                                'active': credentialsInfo?.credentials?.bulkStockSyncEnabled === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                
                    </Box>
                </Box>
                )}
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("sync_virtual_stock")}</Text>
                        <EMGeneralExplainerBox title={t('em_syncvirtualstock_title')} text={t('em_syncvirtualstock_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <NumberInput btnSize={"24"}
                            maxWidth={160}
                            value={credentialsInfo?.virtualSyncAmount}
                            change={(e) => handleChange("virtualSyncAmount", e)}
                        />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("sync_backorder_amount")}</Text>
                        <EMGeneralExplainerBox title={t('sync_backorder_amount')} text={t('em_sync_backorder_amount_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.syncBackorderAmount === true ? "green" : "red"}
                            value={credentialsInfo?.syncBackorderAmount === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("syncBackorderAmount", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.syncBackorderAmount}`, {
                                'active': credentialsInfo?.syncBackorderAmount === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                
                    </Box>
                </Box>
                <Text bold sx={{mt: 2}}>{t("shipments")}</Text>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Text noBreak>{t("sync_shipments")}</Text>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.syncShipments === true ? "green" : "red"}
                            value={credentialsInfo?.syncShipments === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => {
                                if (value === null) return;
                                const boolVal = value === "true";
                                if (boolVal === (credentialsInfo?.syncShipments === true)) return;
                                setShipmentConfirm({ open: true, value: boolVal });
                            }}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.syncShipments}`, {
                                'active': credentialsInfo?.syncShipments === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                
                    </Box>
                </Box>
                {credentialsInfo?.webshop_type === "ccvshop" && (
                <Box 
                    sx={{
                        mt: 1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("do_not_complete_partial_orders")}</Text>
                        <EMGeneralExplainerBox title={t('do_not_complete_partial_orders')} text={t('em_do_not_complete_partial_orders_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.checkForPartialOrders === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.checkForPartialOrders === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.checkForPartialOrders", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.checkForPartialOrders}`, {
                                'active': credentialsInfo?.credentials?.checkForPartialOrders === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                
                    </Box>
                </Box>
                )}
                {credentialsInfo?.webshop_type === "magento" &&
                <Box
                    sx={{
                        mt: 1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Text noBreak>{t("send_tracking_from_webshop")}</Text>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.notifyShipmentFromShop === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.notifyShipmentFromShop === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.notifyShipmentFromShop", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.notifyShipmentFromShop}`, {
                                'active': credentialsInfo?.credentials?.notifyShipmentFromShop === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                }
                {credentialsInfo?.webshop_type === "shopify" &&
                <Box
                    sx={{
                        mt: 1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Text noBreak>{t("register_digital_products")}</Text>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.registerDigitalProducts === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.registerDigitalProducts === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.registerDigitalProducts", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.registerDigitalProducts}`, {
                                'active': credentialsInfo?.credentials?.registerDigitalProducts === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                }
                {showTrackAndTraceMails &&
                <Box
                    sx={{
                        mt: 1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Text noBreak>{t("send_track_and_trace_email")}</Text>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.sendTrackAndTraceEmail === true ? "green" : "red"}
                            value={credentialsInfo?.sendTrackAndTraceEmail === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("sendTrackAndTraceEmail", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.sendTrackAndTraceEmail}`, {
                                'active': credentialsInfo?.sendTrackAndTraceEmail === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                }
                {showTrackAndTraceMails &&
                <Box
                    sx={{
                        mt: 1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Text noBreak>{t("add_pickingslip_to_tracking_mail")}</Text>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.addPickingSlipToTrackingMail === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.addPickingSlipToTrackingMail === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.addPickingSlipToTrackingMail", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.addPickingSlipToTrackingMail}`, {
                                'active': credentialsInfo?.credentials?.addPickingSlipToTrackingMail === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                }
                <Box
                    sx={{
                        mt: 1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("ignore_pickup_mail")}</Text>
                        <EMGeneralExplainerBox title={t('ignore_pickup_mail')} text={t('em_ignore_pickup_mail_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.ignorePickupMail === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.ignorePickupMail === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.ignorePickupMail", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.ignorePickupMail}`, {
                                'active': credentialsInfo?.credentials?.ignorePickupMail === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                <Box
                    sx={{
                        mt: 1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("customs_saleprice_product")}</Text>
                        <EMGeneralExplainerBox title={t('customs_saleprice_product')} text={t('em_customs_saleprice_product_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32,
                            minWidth:120,
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.shippingUseProductSalePrice === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.shippingUseProductSalePrice === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.shippingUseProductSalePrice", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.shippingUseProductSalePrice}`, {
                                'active': credentialsInfo?.credentials?.shippingUseProductSalePrice === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                <Box 
                    sx={{
                        mt: 1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Text noBreak>{t("skip_sync_pickup")}</Text>
                        <EMGeneralExplainerBox title={t('skip_sync_pickup')} text={t('em_skip_sync_pickup_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.skipSyncPickup === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.skipSyncPickup === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.skipSyncPickup", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.skipSyncPickup}`, {
                                'active': credentialsInfo?.credentials?.skipSyncPickup === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                
                    </Box>
                </Box>
            </Dropdown>
            <Dropdown title={t("order_validation")} subTitle={t("dd_order_validation_subtitle")}>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("ignore_address_validation")}</Text>
                        <EMGeneralExplainerBox title={t('ignore_address_validation')} text={t('em_ignore_address_validation_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.validationSettings?.ignoreAddress === true ? "green" : "red"}
                            value={credentialsInfo?.validationSettings?.ignoreAddress === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("validationSettings.ignoreAddress", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.validationSettings?.ignoreAddress}`, {
                                'active': credentialsInfo?.validationSettings?.ignoreAddress === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                        mt:1.5,
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("ignore_address_validation_countries")}</Text>
                        <EMGeneralExplainerBox title={t('ignore_address_validation_countries')} text={t('em_ignore_address_validation_countries_text')}/>
                    </Box>
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                            <InputDropdown
                                searchOptions={{
                                    enabled: true,
                                    placeholder: t("search")
                                }}
                                styles={{
                                    minWidth:300
                                }}
                                closeOnSelection={false}
                                height={32}
                                name="ignorecountries"
                                displayName="name"
                                changeField="alpha2"
                                valueKey="alpha2"
                                multiple
                                selected={credentialsInfo?.validationSettings?.ignoreAddressCountries ?? []}
                                options={countries ?? []}
                                noSelection={t("choose_option")} 
                                onChange={(val) => handleChange("validationSettings.ignoreAddressCountries",val)}
                            />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                        mt:1.5,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("ignore_phone_outside_eu")}</Text>
                        <EMGeneralExplainerBox title={t('ignore_phone_outside_eu')} text={t('em_ignore_phone_outside_eu_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.validationSettings?.ignorePhoneOutsideEU === true ? "green" : "red"}
                            value={credentialsInfo?.validationSettings?.ignorePhoneOutsideEU === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("validationSettings.ignorePhoneOutsideEU", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.validationSettings?.ignorePhoneOutsideEU}`, {
                                'active': credentialsInfo?.validationSettings?.ignorePhoneOutsideEU === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        
                    </Box>
                </Box>
            </Dropdown>
            {["magento", "woocommerce", "shopify"].includes(credentialsInfo?.webshop_type) && (
            <Dropdown title={t('product_fields')} subTitle={t("dd_product_fields_subtitle")}>
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:"column",
                        gap:1.5,
                    }}
                >
                    {credentialsInfo?.webshop_type === "shopify" && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("fetch_product_weight")}</Text>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.fetchProductWeight === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.fetchProductWeight === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.fetchProductWeight", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.fetchProductWeight}`, {
                                'active': credentialsInfo?.credentials?.fetchProductWeight === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        </Box>
                    </Box>
                    )}
                    {!isRelation && credentialsInfo?.webshop_type === "shopify" && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("meta_field_length")}</Text>
                            <EMGeneralExplainerBox title={t('meta_field_length')} text={t('em_meta_field_length_text')}></EMGeneralExplainerBox>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.metaFieldLength"
                                value={credentialsInfo?.credentials?.metaFieldLength ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {!isRelation && credentialsInfo?.webshop_type === "shopify" && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("meta_field_width")}</Text>
                            <EMGeneralExplainerBox title={t('meta_field_width')} text={t('em_meta_field_width_text')}></EMGeneralExplainerBox>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.metaFieldWidth"
                                value={credentialsInfo?.credentials?.metaFieldWidth ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {!isRelation && credentialsInfo?.webshop_type === "shopify" && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("meta_field_height")}</Text>
                            <EMGeneralExplainerBox title={t('meta_field_height')} text={t('em_meta_field_height_text')}></EMGeneralExplainerBox>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.metaFieldHeight"
                                value={credentialsInfo?.credentials?.metaFieldHeight ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {(credentialsInfo?.webshop_type === "woocommerce" || credentialsInfo?.webshop_type === "magento") && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("hs_code")}</Text>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="productFields.hscode"
                                value={credentialsInfo?.productFields?.hscode ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {(credentialsInfo?.webshop_type === "woocommerce" || credentialsInfo?.webshop_type === "magento") && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("country_of_origin")}</Text>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="productFields.countryOfOrigin"
                                value={credentialsInfo?.productFields?.countryOfOrigin ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {(credentialsInfo?.webshop_type === "woocommerce" || credentialsInfo?.webshop_type === "magento") && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("barcode")}</Text>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="productFields.barcode"
                                value={credentialsInfo?.productFields?.barcode ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "magento" && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("reject_on_return")}</Text>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="productFields.rejectOnReturn"
                                value={credentialsInfo?.productFields?.rejectOnReturn ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "magento" && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("cost_price")}</Text>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="productFields.purchasePrice"
                                value={credentialsInfo?.productFields?.purchasePrice ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {(credentialsInfo?.webshop_type === "magento" || credentialsInfo?.webshop_type === "shopify") && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("supplier")}</Text>
                        </Box>
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="productFields.supplier"
                                value={credentialsInfo?.productFields?.supplier ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                </Box>
            </Dropdown>
            )}
             <Dropdown title={t('orders')} subTitle={t("dd_orders_subtitle")}>
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:"column",
                        gap:1.5,
                    }}
                >
                    {(credentialsInfo?.webshop_type === "mirakl" || credentialsInfo?.integratorId > 0) && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("dummy_email")}</Text>
                            <EMGeneralExplainerBox title={t('dummy_email')} text={t('em_dummy_email_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.dummy_email"
                                value={credentialsInfo?.credentials?.dummy_email ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "shopify" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("import_paid_state_tag")}</Text>
                            <EMGeneralExplainerBox title={t('import_paid_state_tag')} text={t('em_import_paid_state_tag_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.import_paid_state_tag"
                                value={credentialsInfo?.credentials?.import_paid_state_tag ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {shopsWithPrefixOptions.includes(credentialsInfo?.webshop_type) && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("ignore_prefix")}</Text>
                            <EMGeneralExplainerBox title={t('em_ignore_prefix_title')} text={t('em_ignore_prefix_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.ignore_prefix"
                                value={credentialsInfo?.credentials?.ignore_prefix ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {shopsWithPrefixOptions.includes(credentialsInfo?.webshop_type) && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("import_prefix")}</Text>
                            <EMGeneralExplainerBox title={t('em_import_prefix_title')} text={t('em_import_prefix_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.import_prefix"
                                value={credentialsInfo?.credentials?.import_prefix ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "shopify" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("ignore_tag_prefix")}</Text>
                            <EMGeneralExplainerBox title={t('ignore_tag_prefix')} text={t('em_ignore_tag_prefix_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.ignore_tag_prefix"
                                value={credentialsInfo?.credentials?.ignore_tag_prefix ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "shopify" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("import_tag_prefix")}</Text>
                            <EMGeneralExplainerBox title={t('import_tag_prefix')} text={t('em_import_tag_prefix_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.import_tag_prefix"
                                value={credentialsInfo?.credentials?.import_tag_prefix ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "shopify" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("tags_for_remark")}</Text>
                            <EMGeneralExplainerBox title={t('em_tags_for_remark_title')} text={t('em_tags_for_remark_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.tags_for_remark"
                                value={credentialsInfo?.credentials?.tags_for_remark ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "shopify" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("tags_for_b2b")}</Text>
                            <EMGeneralExplainerBox title={t('tags_for_b2b')} text={t('em_tags_for_b2b_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.tags_for_b2b"
                                value={credentialsInfo?.credentials?.tags_for_b2b ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "shopify" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("pickup_shipping_line_code")}</Text>
                            <EMGeneralExplainerBox title={t('pickup_shipping_line_code')} text={t('em_pickup_shipping_line_code_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.pickup_shipping_line_code"
                                value={credentialsInfo?.credentials?.pickup_shipping_line_code ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "shopify" && (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >

                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("pickup_order_tag")}</Text>
                            <EMGeneralExplainerBox title={t('pickup_order_tag')} text={t('em_pickup_order_tag_text')}></EMGeneralExplainerBox>
                        </Box>

                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.pickup_order_tag"
                                value={credentialsInfo?.credentials?.pickup_order_tag ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "shopify" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text noBreak>{t("import_lines_from_location")}</Text>
                            <EMGeneralExplainerBox title={t('import_lines_from_location')} text={t('em_import_lines_from_location_text')}/>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32
                            }}
                        >
                            <ToggleButtonGroup
                                color={credentialsInfo?.credentials?.import_lines_from_location === true ? "green" : "red"}
                                value={credentialsInfo?.credentials?.import_lines_from_location === true ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("credentials.import_lines_from_location", value === "true")}
                                aria-label="Active"
                                className={cx(`${credentialsInfo?.credentials?.import_lines_from_location}`, {
                                    'active': credentialsInfo?.credentials?.import_lines_from_location === true
                                })}
                                sx={{
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                            
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "magento" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("b2b_prefix")}</Text>
                            <EMGeneralExplainerBox title={t('em_b2b_prefix_title')} text={t('em_b2b_prefix_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.b2b_prefix"
                                value={credentialsInfo?.credentials?.b2b_prefix ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "magento" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("fields_for_remark")}</Text>
                            <EMGeneralExplainerBox title={t('em_fields_for_remark_title')} text={t('em_fields_for_remark_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.fields_for_remark"
                                value={credentialsInfo?.credentials?.fields_for_remark ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                    {credentialsInfo?.webshop_type === "magento" && (
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:2,
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            p:0.5,
                            borderRadius:6,
                            pl:2,
                            mt:1.5,
                        }}
                    >
                        
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                            }}
                        >
                            <Text>{t("fields_for_customer_reference")}</Text>
                            <EMGeneralExplainerBox title={t('fields_for_customer_reference')} text={t('em_fields_for_customer_reference_text')}></EMGeneralExplainerBox>
                        </Box>
                        
                        <Box
                            sx={{
                                borderRadius:4,
                                display:"flex",
                                height:32,
                                minwidth: 300
                            }}
                        >
                            <ShValidatedInput
                                name="credentials.fields_for_customer_reference"
                                value={credentialsInfo?.credentials?.fields_for_customer_reference ?? ""}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    )}
                </Box>
            </Dropdown>
            { /* Returns */}
            {credentialsInfo?.webshop_type === "bol" && (
            <Dropdown title={t('returns')} subTitle={t("dd_returns_subtitle")}>
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:"column",
                        gap:1.5,
                    }}
                >
                    <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        p:0.5,
                        borderRadius:6,
                        pl:2,
                        mt:1.5,
                    }}
                >
                    
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            overflow:"hidden",
                        }}
                    >
                        <Text noBreak>{t("import_non_sh_return")}</Text>
                        <EMGeneralExplainerBox title={t('import_non_sh_return')} text={t('em_import_non_sh_return_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ToggleButtonGroup
                            color={credentialsInfo?.credentials?.importNonSHReturn === true ? "green" : "red"}
                            value={credentialsInfo?.credentials?.importNonSHReturn === true ? "true" : "false"}
                            exclusive
                            onChange={(e,value) => handleChange("credentials.importNonSHReturn", value === "true")}
                            aria-label="Active"
                            className={cx(`${credentialsInfo?.credentials?.importNonSHReturn}`, {
                                'active': credentialsInfo?.credentials?.importNonSHReturn === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton 
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        
                    </Box>
                </Box>
                </Box>
            </Dropdown>
            )}
            {/* Information Section */}
            <Dropdown title={t('skip_products_stock')} subTitle={t("dd_skip_products_stock_subtitle")} explainer={<EMGeneralExplainerBox title={t('em_webshop_skip_product_stock_title')} text={t('em_webshop_skip_product_stock_text')}/>}>
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:"column",
                        gap:1.5,
                    }}
                >
                    {credentialsInfo?.ignoreStockBarcodes?.length > 0 && credentialsInfo.ignoreStockBarcodes.map((barcode, index) => (
                    <Box 
                        key={"ign-barcode"+index}
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            gap:1,
                            "@media screen and (max-width:47.9375em)" : {
                                width:1,
                                justifyContent:"space-between",
                            }
                        }}
                    >
                        <Box
                            sx={{
                                width:220,
                                "@media screen and (max-width:63.9375em)" : {
                                    width:130,
                                }
                            }}
                        >
                            <Text light>{t('barcode')} (SKU)</Text>
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            backgroundColor={`${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`}
                            sx={{
                                flex:1,
                                justifyContent:"space-between",
                            }}
                        >
                        <Box sx={{
                                flex:1,
                                backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                                borderRadius:32/8,
                                display:"flex",
                                height:`32px`,
                            }}
                        >
                            <InputBase 
                                type="text"
                                sx={{
                                    px:2,
                                    flex:1, 
                                    color:colors.txt["primary"],
                                    lineHeight:`32px`,
                                }}
                                value={barcode}
                                onChange={(e) => handleStockBarcodeChange(index, e.target.value)}
                            />
                            <IconButton type="button" onClick={() => handleDeleteStockBarcode(index)}
                            sx={{ 
                                color: colors.txt["primary"]
                            }}>
                                <DeleteIcon/>
                            </IconButton>
                        </Box>
                        </Box>
                    </Box>
                    ))}
                    <Box sx={{marginLeft: 1}}>
                        <Shbutton 
                            block
                            // className={"group-btn"} 
                            color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                            variant="contained" 
                            startIcon={<AddIcon/>}
                            onClick={() => handleNewStockBarcodeRow()}
                        >
                            {t("new")}
                        </Shbutton>
                    </Box>
                </Box>
            </Dropdown>
            {/* Information Section */}
            <Dropdown title={t('skip_products')} subTitle={t("dd_skip_products_subtitle")} explainer={<EMGeneralExplainerBox title={t('em_webshop_skip_product_title')} text={t('em_webshop_skip_product_text')}/>}>
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:"column",
                        gap:1.5,
                    }}
                >
                    {credentialsInfo?.ignoreBarcodes?.length > 0 && (
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"space-between",
                                gap:1,
                                flexWrap:"wrap",
                            }}
                        >
                            <Text bold>{credentialsInfo.ignoreBarcodes.length} {t('barcodes')}</Text>
                            <Box display="flex"
                                alignItems="center"
                                borderRadius="20px"
                                backgroundColor={`${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`}
                                sx={{ height:`32px`, px:1.5 }}
                            >
                                <SearchIcon sx={{ fontSize:18, color:colors.txt["primary"] }}/>
                                <InputBase
                                    type="text"
                                    placeholder={t('search')}
                                    sx={{ px:1, color:colors.txt["primary"], lineHeight:`32px` }}
                                    value={ignoreBarcodeSearch}
                                    onChange={(e) => setIgnoreBarcodeSearch(e.target.value)}
                                />
                            </Box>
                        </Box>
                    )}
                    {(credentialsInfo?.ignoreBarcodes ?? [])
                        .map((barcode, index) => ({ barcode, index }))
                        .filter(({ barcode }) => !debouncedIgnoreBarcodeSearch || (barcode ?? "").toLowerCase().includes(debouncedIgnoreBarcodeSearch.toLowerCase()))
                        .map(({ barcode, index }) => (
                    <Box
                        key={"ign-barcode"+index}
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            gap:1,
                            "@media screen and (max-width:47.9375em)" : {
                                width:1,
                                justifyContent:"space-between",
                            }
                        }}
                    >
                        <Box
                            sx={{
                                width:220,
                                "@media screen and (max-width:63.9375em)" : {
                                    width:130,
                                }
                            }}
                        >
                            <Text light>{t('barcode')} (SKU)</Text>
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            backgroundColor={`${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`}
                            sx={{
                                flex:1,
                                justifyContent:"space-between",
                            }}
                        >
                        <Box sx={{
                                flex:1,
                                backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                                borderRadius:32/8,
                                display:"flex",
                                height:`32px`,
                            }}
                        >
                            <InputBase 
                                type="text"
                                sx={{
                                    px:2,
                                    flex:1, 
                                    color:colors.txt["primary"],
                                    lineHeight:`32px`,
                                }}
                                value={barcode}
                                onChange={(e) => handleBarcodeChange(index, e.target.value)}
                            />
                            <IconButton type="button" onClick={() => handleDeleteBarcode(index)}
                            sx={{ 
                                color: colors.txt["primary"]
                            }}>
                                <DeleteIcon/>
                            </IconButton>
                        </Box>
                        </Box>
                    </Box>
                    ))}
                    <Box sx={{marginLeft: 1, display:"flex", gap:1, flexWrap:"wrap"}}>
                        <Shbutton
                            block
                            // className={"group-btn"}
                            color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                            variant="contained"
                            startIcon={<AddIcon/>}
                            onClick={() => handleNewBarcodeRow()}
                        >
                            {t("new")}
                        </Shbutton>
                        <Shbutton
                            block
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                            variant="contained"
                            startIcon={<AddIcon/>}
                            onClick={() => setShowBulkIgnoreModal(true)}
                        >
                            {t("add_bulk")}
                        </Shbutton>
                    </Box>
                </Box>
            </Dropdown>
            <MDynamicValues
                open={showBulkIgnoreModal}
                handleClose={() => setShowBulkIgnoreModal(false)}
                title={"bulk_add_barcodes"}
                message={bulkBarcodeMessage}
                fields={bulkBarcodeFields}
                onConfirm={handleBulkAddIgnoreBarcodes}
            />
            {/* Information Section */}
            <Dropdown title={t('import_selected_only')} subTitle={t("dd_import_selected_only_subtitle")}>
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:"column",
                        gap:1.5,
                    }}
                >
                    {credentialsInfo?.importBarcodeWhitelist?.length > 0 && (
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"space-between",
                                gap:1,
                                flexWrap:"wrap",
                            }}
                        >
                            <Text light>{credentialsInfo.importBarcodeWhitelist.length} {t('barcodes')}</Text>
                            <Box display="flex"
                                alignItems="center"
                                borderRadius="20px"
                                backgroundColor={`${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`}
                                sx={{ height:`32px`, px:1.5 }}
                            >
                                <SearchIcon sx={{ fontSize:18, color:colors.txt["primary"] }}/>
                                <InputBase
                                    type="text"
                                    placeholder={t('search')}
                                    sx={{ px:1, color:colors.txt["primary"], lineHeight:`32px` }}
                                    value={whitelistBarcodeSearch}
                                    onChange={(e) => setWhitelistBarcodeSearch(e.target.value)}
                                />
                            </Box>
                        </Box>
                    )}
                    {(credentialsInfo?.importBarcodeWhitelist ?? [])
                        .map((barcode, index) => ({ barcode, index }))
                        .filter(({ barcode }) => !debouncedWhitelistBarcodeSearch || (barcode ?? "").toLowerCase().includes(debouncedWhitelistBarcodeSearch.toLowerCase()))
                        .map(({ barcode, index }) => (
                    <Box
                        key={"wl-barcode"+index}
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            gap:1,
                            "@media screen and (max-width:47.9375em)" : {
                                width:1,
                                justifyContent:"space-between",
                            }
                        }}
                    >
                        <Box
                            sx={{
                                width:220,
                                "@media screen and (max-width:63.9375em)" : {
                                    width:130,
                                }
                            }}
                        >
                            <Text light>{t('barcode')} (SKU)</Text>
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            backgroundColor={`${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`}
                            sx={{
                                flex:1,
                                justifyContent:"space-between",
                            }}
                        >
                        <Box sx={{
                                flex:1,
                                backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                                borderRadius:32/8,
                                display:"flex",
                                height:`32px`,
                            }}
                        >
                            <InputBase 
                                type="text"
                                sx={{
                                    px:2,
                                    flex:1, 
                                    color:colors.txt["primary"],
                                    lineHeight:`32px`,
                                }}
                                value={barcode}
                                onChange={(e) => handleWhitelistBarcodeChange(index, e.target.value)}
                            />
                            <IconButton type="button" onClick={() => handleDeleteWhitelistBarcode(index)}
                            sx={{ 
                                color: colors.txt["primary"]
                            }}>
                                <DeleteIcon/>
                            </IconButton>
                        </Box>
                        </Box>
                    </Box>
                    ))}
                    <Box sx={{marginLeft: 1, display:"flex", gap:1, flexWrap:"wrap"}}>
                        <Shbutton
                            block
                            // className={"group-btn"}
                            color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                            variant="contained"
                            startIcon={<AddIcon/>}
                            onClick={() => handleNewWhitelistBarcodeRow()}
                        >
                            {t("new")}
                        </Shbutton>
                        <Shbutton
                            block
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                            variant="contained"
                            startIcon={<AddIcon/>}
                            onClick={() => setShowBulkWhitelistModal(true)}
                        >
                            {t("add_bulk")}
                        </Shbutton>
                    </Box>
                </Box>
            </Dropdown>
            <MDynamicValues
                open={showBulkWhitelistModal}
                handleClose={() => setShowBulkWhitelistModal(false)}
                title={"bulk_add_barcodes"}
                message={bulkBarcodeMessage}
                fields={bulkBarcodeFields}
                onConfirm={handleBulkAddWhitelistBarcodes}
            />

                    
            <SpDesktopFooter>
                <GridActions
                    hasModifyPermission={hasModifyPermission}
                    isLoading={isLoading}
                    id={credentialsInfo?.id}
                    action={handleSaveClick}
                    syncAction={handleSyncClick}
                    deleteAction={handleDeleteClick}
                />
            </SpDesktopFooter>
            <MConfirmDelete
                open={confirmDeleteModal.open}
                handleClose={() => confirmDeleteModal.setOpen(false)}
                data={confirmDeleteModal.data}
                confirm={confirmDeleteModal.confirm}
            />
            <MConfirmation
                open={shipmentConfirm.open}
                handleClose={() => setShipmentConfirm({ ...shipmentConfirm, open: false })}
                title={shipmentConfirm.value ? t("sync_shipments_enable_title") : t("sync_shipments_disable_title")}
                confirm={confirmShipmentChange}
                content={
                    <Box
                        component="span"
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"flex-start",
                            gap:1.5,
                            p:2,
                            borderRadius:3,
                            textAlign:"left",
                            background: shipmentConfirm.value ? colors.green[100] : colors.red[100],
                        }}
                    >
                        {shipmentConfirm.value
                            ? <CheckCircleOutlineRoundedIcon sx={{ color: colors.green[400], fontSize:20, mt:"2px", flexShrink:0 }}/>
                            : <WarningAmberRoundedIcon sx={{ color: colors.red[400], fontSize:20, mt:"2px", flexShrink:0 }}/>}
                        <Text sx={{ color: shipmentConfirm.value ? colors.green[400] : colors.red[400] }}>
                            {shipmentConfirm.value ? t("sync_shipments_enable_text") : t("sync_shipments_disable_text")}
                        </Text>
                    </Box>
                }
            />
        </Box>
                
    );
}

export default Sync;
